module.exports = __webpack_public_path__ + "img/be.02ffafb7.svg";